import { api, formatParams, config } from "@/utils/axios";

// 获取部门列表
export function getDpList(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/section/findAll`,
    })
  );
}

// 删除部门
export function delSection(params) {
  return api(
    Object.assign(formatParams("GET", params), {
      url: `${config.proxy}/dynamic-form/section/del/${params.id}`,
    })
  );
}

// 新增部门
export function saveSection(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/section/saveSection`,
    })
  );
}

// 编辑部门
export function updateSection(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/section/update/${params.id}`,
    })
  );
}

// 用户部门绑定
export function saveSectionAndUser(params) {
  return api(
    Object.assign(formatParams("POST", params), {
      url: `${config.proxy}/dynamic-form/section/saveSectionAndUser`,
    })
  );
}

// 用户部门绑定
export function sectionAndUser(params) {
  return api(
    Object.assign(formatParams("GET"), {
      url: `${config.proxy}/dynamic-form/section/sectionAndUser/${params}`,
    })
  );
}
